// src/Services/api.js

import axios from 'axios';
import { API_URL } from "./constant";

// Axios instance create
export const axiosConfig = axios.create({
    baseURL: API_URL,
    responseType: "json",
    withCredentials: true,
    headers: {
        "Content-Type": "application/json",
    },
});

// Request interceptor to add token dynamically
axiosConfig.interceptors.request.use(
    (config) => {
        const userToken = localStorage.getItem('access_token');
        const adminToken = localStorage.getItem('adminToken');

        if (userToken || adminToken) {
            config.headers["Authorization"] = `Bearer ${userToken || adminToken}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// GET request
export const getData = async (endpoint) => {
    try {
        const response = await axiosConfig.get(endpoint);
        return response.data;
    } catch (error) {
        return error?.response?.data;
    }
};

// POST request
export const postData = async (endpoint, body) => {
    try {
        const response = await axiosConfig.post(endpoint, body);
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

// PUT request
export const putData = async (endpoint, data) => {
    try {
        const response = await axiosConfig.put(endpoint, data);
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

// DELETE request
export const deleteData = async (endpoint) => {
    try {
        const response = await axiosConfig.delete(endpoint);
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};
